document.querySelector('#footerFormKlaviyo')?.addEventListener('submit', async function (e) {
    // if need to resubmit, try and force
    if (!this.classList.contains('ignoreChecks')) {
        e.preventDefault();
        e.stopImmediatePropagation();
    }

    // for error messages
    const errorMessage = this.querySelector('#footerFormError');
    // reset message
    errorMessage.textContent = "";

    // if there is a checkbox
    if (this.querySelector('#footerFormPolicy')) {
        if (this.querySelector('#footerFormPolicyLabelInput').checked === false) {
            errorMessage.textContent = "Please complete all the required fields.";
            return;
        }
    }

    // Validate email
    const emailEl = this.querySelector('.email');
    const email = emailEl?.value.trim();
    if (!validateEmail(email)) {
        errorMessage.textContent = 'Please provide a valid email address.';
        return;
    }

    // Prepare submission
    const url = this.dataset.ajaxSubmit;
    const formData = new FormData(this);

    try {
        const response = await fetch(url, {
            method: 'POST',
            body: formData
        });

        if (response.redirected && response.url.includes('/challenge')) {
            // re-submit to trigger captcha if necessary
            this.classList.add('ignoreChecks');
            this.submit();
        } else {
            // show success and hide form
            this.querySelector('#footerFormSuccess').classList.add('active');
            this.querySelector('#footerFormSuccess').focus();
            this.querySelector('#footerFormWrap').style.display = 'none';
            this.querySelector('#footerFormPolicy').style.display = 'none';
        }
    } catch (err) {
        // On network or server error, fallback to normal form submit
        this.classList.add('ignoreChecks');
        this.submit();
    }
})